import React from 'react'
import PropTypes from 'prop-types'
import WarningIcon from '../../../components/icons/WarningIcon'
import {Flex, Text, Link, useStyleConfig} from '@chakra-ui/react'

const ProductRecall = ({productRecall, variant = ''}) => {
    // const appOrigin = useOrigin(false)
    const styles = useStyleConfig('Paperless', {variant})

    return (
        <Flex {...styles?.productRecallContainer} data-testid="product-recall-container">
            <WarningIcon {...styles?.recallIcon} />
            <Text {...styles?.recallText}>
                {productRecall?.text}
                <Link
                    {...styles?.recallLink}
                    href={productRecall?.hreflink}
                    data-testid="product-recall-link"
                >
                    {productRecall?.cta_text}
                </Link>
            </Text>
        </Flex>
    )
}

ProductRecall.propTypes = {variant: PropTypes.string, productRecall: PropTypes.object}
export default ProductRecall
